







import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import QrInitInfo from "../qr/QrInitInfo.vue";
import rd from "../../modules/vRoutedefs";

@Component({
    components: {
        "init-info": QrInitInfo,
    }
})
export default class QrPreReader extends CommonBase {


    get qrCardreadTo() {
        return {path: rd.start.card.add.qrReader.path};
    }
    get cancelTo() {
        return {name: rd.start.name};
    }
}
